/*
 * @Author: your name
 * @Date: 2021-12-03 16:31:19
 * @LastEditTime: 2022-03-15 14:02:25
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\cas\sso.js
 */
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import store from '@/store'
import { userManager } from '../utils/user_manager';
import { isOAuth2AppEnv } from '@/utils/util'

/**
 * 单点登录
 */
const init = async (callback) => {
  if (process.env.VUE_APP_SSO == 'true' && !isOAuth2AppEnv()) {

    console.log('----------开始designorder的登录流程------------')
    userManager.registerOnLoginCallback(user => {
      Vue.ls.set(ACCESS_TOKEN, user.token);
      validateDo(callback);
    })
    userManager.registeronLogoutCallback(user => {
      userManager.redirectToLogin();
    })

    if (!await userManager.checkLogin()) {
      if (!getUrlParam('token')) {
        userManager.redirectToLogin();
      }
    }


    // console.log("-------单点登录开始-------");
    // let token = Vue.ls.get(ACCESS_TOKEN);
    // let st = getUrlParam("ticket");
    // let sevice = "http://" + window.location.host + "/";
    // if (token) {
    //   loginSuccess(callback);
    // } else {
    //   if (st) {
    //     validateSt(st, sevice, callback);
    //   } else {
    //     let serviceUrl = encodeURIComponent(sevice);
    //     window.location.href = window._CONFIG['casPrefixUrl'] + "/login?service=" + serviceUrl;
    //   }
    // }
    // console.log("-------单点登录结束-------");
  } else {
    callback && callback()
  }
};
const SSO = {
  init: init
};

function getUrlParam(paraName) {
  let url = document.location.toString();
  let arrObj = url.split("?");

  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  }
  else {
    return "";
  }
}

function validateDo(callback) {
  store.dispatch('ValidateLoginDo').then(res => {
    //this.departConfirm(res)
    if (res.success) {
      loginSuccess(callback);
    } else {
      let sevice = "http://" + window.location.host + "/";
      let serviceUrl = encodeURIComponent(sevice);
      window.location.href = window._CONFIG['casPrefixUrl'] + "/login?service=" + serviceUrl;
    }
  }).catch((err) => {
    console.log(err);
    //that.requestFailed(err);
  });
}

function validateSt(ticket, service, callback) {
  let params = {
    ticket: ticket,
    service: service
  };
  store.dispatch('ValidateLogin', params).then(res => {
    //this.departConfirm(res)
    if (res.success) {
      loginSuccess(callback);
    }
  }).catch((err) => {
    console.log(err);
    //that.requestFailed(err);
  });
}

function loginSuccess(callback) {
  callback();
}
export default SSO;